export default __webpack_public_path__ + "static/Krzysztof Paczuski-3a63af00f303bd2d41e001969c5489fb.jpg";